export const getOrCreateDeviceId = () => {
  try {
    const key = "moo_device_id";
    const legacyPosKey = "moo_pos_device_id";
    const existing = window.localStorage.getItem(key);
    if (existing) {
      // La caisse utilisait historiquement une seconde clé pour le même
      // appareil. Garder les deux valeurs alignées évite qu'un jeton créé au
      // login soit ensuite rejeté par une route métier avec « Token invalide ».
      if (window.localStorage.getItem(legacyPosKey) !== existing) {
        window.localStorage.setItem(legacyPosKey, existing);
      }
      return existing;
    }

    const legacyPosId = String(
      window.localStorage.getItem(legacyPosKey) || "",
    ).trim();
    if (legacyPosId) {
      window.localStorage.setItem(key, legacyPosId);
      return legacyPosId;
    }

    const id =
      (window.crypto && typeof window.crypto.randomUUID === "function"
        ? window.crypto.randomUUID()
        : `dev_${Date.now()}_${Math.random().toString(16).slice(2)}`) || "";

    window.localStorage.setItem(key, id);
    window.localStorage.setItem(legacyPosKey, id);
    return id;
  } catch (_e) {
    // Fallback si localStorage indisponible
    return `dev_${Date.now()}_${Math.random().toString(16).slice(2)}`;
  }
};

export const getDeviceName = () => {
  try {
    const ua = navigator.userAgent || "";
    if (/ipad/i.test(ua)) return "iPad";
    if (/iphone/i.test(ua)) return "iPhone";
    if (/android/i.test(ua)) return "Android";
    if (/windows/i.test(ua)) return "Windows";
    if (/macintosh|mac os/i.test(ua)) return "Mac";
    return "Appareil";
  } catch (_e) {
    return "Appareil";
  }
};
